<template>
  <div class="lhr">
    <span class="lhr-label">Hospital and service line</span>
    <div class="lhr-row">
      <span class="lhr-val">
        <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4a5568" stroke-width="2" stroke-linecap="round"><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>
        <strong>{{ text }}</strong>
      </span>
      <span class="lhr-set">Set by this audit</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LockedHospitalRow',
  props: { hospital: { type: String, default: '' }, serviceLine: { type: String, default: '' } },
  computed: {
    text() {
      return [this.hospital, this.serviceLine].filter(Boolean).join(' · ')
    }
  }
}
</script>

<style scoped>
.lhr { display: flex; flex-direction: column; gap: 6px; }
.lhr-label { font-size: 13px; font-weight: 600; }
.lhr-row { display: flex; align-items: center; justify-content: space-between; gap: 10px; min-height: 48px; padding: 0 14px; border-radius: 10px; background: #f7f4ec; color: #0d1e35; }
.lhr-val { display: flex; align-items: center; gap: 8px; font-size: 15px; }
.lhr-set { font-size: 12px; color: #4a5568; }
</style>
